/* Little Leo · Landingpage-Verhalten: Einblenden, Streifen, Löwe, Menü, Konfetti, Terminart, Bühnen-Neigung.
   Design: Studio Jonas Becker (BrandOS), umgesetzt für LEO Stores. Läuft je Section neu (auch im Theme-Editor). */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hopMs = () => {
    const el = document.querySelector('.ll');
    return (el && parseFloat(getComputedStyle(el).getPropertyValue('--logo-motion-interval')) * 1000) || 7000;
  };

  // Konfetti in Palettenfarben, auf Wunsch mit Löwen-Stickern. Liegt hinter dem Inhalt und bleibt im Abschnitt.
  const PALETTE = [1, 2, 3, 4, 5, 6].map((n) => `var(--confetti-${n})`);
  function burst(el, { count = 60, lions = 0, spread = 480 } = {}) {
    if (reduce || !el) return;
    const host = el.closest('.ll-card, .ll-party');
    const bound = el.closest('section');
    if (!host || !bound) return;
    const box = Object.assign(document.createElement('div'), { className: 'll-confetti' });
    host.append(box);
    const h = host.getBoundingClientRect(), b = bound.getBoundingClientRect(), r = el.getBoundingClientRect();
    const pad = 24;
    const pieces = [];
    for (let i = 0; i < count; i++) {
      const bit = document.createElement('i');
      const w = 7 + Math.random() * 9, round = Math.random() < .25;
      Object.assign(bit.style, {
        width: `${w}px`, height: `${round ? w : w * 1.9}px`,
        borderRadius: round ? '50%' : '2px', background: PALETTE[i % PALETTE.length],
      });
      pieces.push(bit);
    }
    for (let i = 0; i < lions; i++) {
      const s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      s.setAttribute('viewBox', '0 0 120.2 113.6');
      s.innerHTML = '<use href="#ll-lion-sticker" width="120.2" height="113.6"/>';
      pieces.push(s);
    }
    for (const p of pieces) {
      const x = r.left + r.width * (.3 + Math.random() * .4), y = r.top + r.height * (.35 + Math.random() * .3);
      p.style.left = `${x - h.left}px`;
      p.style.top = `${y - h.top}px`;
      box.append(p);
      const dx = Math.max(b.left + pad - x, Math.min(b.right - pad - x, (Math.random() - .5) * spread));
      const up = Math.min(180 + Math.random() * 300, y - b.top - pad);
      const fall = Math.max(0, Math.min(innerHeight * .85, b.bottom - pad - y));
      const rot = (Math.random() - .5) * 1440;
      p.animate([
        { transform: 'translate(0,0) rotate(0deg) scale(.6)', opacity: 1 },
        { transform: `translate(${dx * .55}px,${-up}px) rotate(${rot / 3}deg) scale(1)`, opacity: 1, offset: .32 },
        { transform: `translate(${dx}px,${fall}px) rotate(${rot}deg) scale(1)`, opacity: 0 },
      ], { duration: 2200 + Math.random() * 1200, delay: Math.random() * 180, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards' });
    }
    setTimeout(() => box.remove(), 3800);
  }

  // Terminart: Links mit data-type und das Formular zeigen dasselbe
  function setType(type, celebrate) {
    const input = document.querySelector(`.ll-form input[data-type="${type}"]`);
    if (!input) return;
    input.checked = true;
    input.closest('.ll-card')?.classList.toggle('is-fitting', type === 'fitting');
    if (celebrate) burst(input.nextElementSibling, { count: 40, spread: 360 });
  }

  function init(root) {
    // Einblenden: Bühnen bauen ihre Streifen auf, Blöcke gleiten herein
    const reveal = new IntersectionObserver((entries) => {
      for (const e of entries) if (e.isIntersecting) { e.target.classList.add('is-in'); reveal.unobserve(e.target); }
    }, { rootMargin: '0px 0px -10% 0px' });
    const striped = [...root.querySelectorAll('.ll-stage__stripes')].map((st) => st.parentElement);
    root.querySelectorAll('.ll-reveal, .ll-stage').forEach((el) => { if (!striped.includes(el)) reveal.observe(el); });

    // Streifen bauen sich bei jedem Hereinkommen neu auf
    const stripes = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting && e.intersectionRatio > .15) e.target.classList.add('is-in');
        else if (!e.isIntersecting) e.target.classList.remove('is-in');
      }
    }, { threshold: [0, .15] });
    striped.forEach((el) => stripes.observe(el));

    // Löwe im Kopf: Hallo-Wackeln, danach ab und zu ein Hüpfer
    const lion = root.querySelector('.ll-brand__lion');
    if (lion) {
      lion.addEventListener('animationend', () => lion.classList.remove('is-hello', 'is-hop'));
      if (!reduce) {
        lion.classList.add('is-hello');
        setInterval(() => { if (!lion.classList.contains('is-hello') && !document.hidden) lion.classList.add('is-hop'); }, hopMs());
      }
    }

    // Lockup im Seitenfuß: Löwe wobbelt herein, sobald sichtbar, dann ab und zu ein Hüpfer
    const live = root.querySelector('.ll-lockup-live');
    const liveLion = live?.querySelector('.ll-lockup-live__lion');
    if (live && liveLion) {
      let seen = false;
      liveLion.addEventListener('animationend', () => { liveLion.classList.add('is-done'); liveLion.classList.remove('is-hop'); });
      new IntersectionObserver(([e]) => { seen = e.isIntersecting; if (seen) live.classList.add('is-in'); }, { threshold: .5 }).observe(live);
      if (!reduce) setInterval(() => { if (seen && liveLion.classList.contains('is-done')) liveLion.classList.add('is-hop'); }, hopMs());
      else live.classList.add('is-in');
    }

    // Menü mobil
    const header = root.querySelector('.ll-site-header');
    const toggle = header?.querySelector('.ll-nav-toggle');
    if (header && toggle) {
      const setMenu = (open) => {
        header.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
      };
      toggle.addEventListener('click', () => setMenu(!header.classList.contains('is-open')));
      header.querySelectorAll('.ll-site-nav a').forEach((a) => a.addEventListener('click', () => setMenu(false)));
      addEventListener('keydown', (e) => { if (e.key === 'Escape' && header.classList.contains('is-open')) { setMenu(false); toggle.focus(); } });
      document.addEventListener('click', (e) => { if (header.classList.contains('is-open') && !header.contains(e.target)) setMenu(false); });

      // Aktiver Menüpunkt folgt dem Abschnitt im Bild
      const navLinks = [...header.querySelectorAll('.ll-site-nav a[href^="#"]')];
      const targets = navLinks.map((a) => document.getElementById(a.getAttribute('href').slice(1))).filter(Boolean);
      const spy = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (!e.isIntersecting) continue;
          navLinks.forEach((a) => {
            const on = a.getAttribute('href') === '#' + e.target.id;
            a.classList.toggle('is-active', on);
            if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
          });
        }
      }, { rootMargin: '-45% 0px -50% 0px' });
      targets.forEach((t) => spy.observe(t));
    }

    // Ranzen-Party: Konfetti hinter dem Knopf, sobald er ganz im Bild ist und beim Überfahren
    root.querySelectorAll('.ll-party__side .ll-cta').forEach((btn) => {
      let armed = true, last = 0;
      const pop = (opts) => { const now = Date.now(); if (now - last < 1500) return; last = now; burst(btn, opts); };
      new IntersectionObserver(([e]) => {
        if (e.isIntersecting && armed && btn.offsetParent) { armed = false; setTimeout(() => pop(), 300); }
        if (!e.isIntersecting) armed = true;
      }, { threshold: 1 }).observe(btn);
      btn.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') pop({ count: 40, spread: 360 }); });
    });

    // Terminformular
    const form = root.querySelector('.ll-form');
    if (form) {
      const checked = form.querySelector('input[data-type]:checked');
      if (checked) setType(checked.dataset.type);
      form.querySelectorAll('input[data-type]').forEach((i) => i.addEventListener('change', () => setType(i.dataset.type, true)));

      // „Termin anfragen!“ wackelt, solange er im Bild ist
      const send = form.querySelector('.ll-form__send .ll-cta');
      if (send && !reduce) {
        const wiggle = () => { send.classList.remove('is-wiggle'); void send.offsetWidth; send.classList.add('is-wiggle'); };
        send.addEventListener('animationend', () => send.classList.remove('is-wiggle'));
        let visible = false;
        new IntersectionObserver(([e]) => {
          const now = e.intersectionRatio >= .6;
          if (now && !visible) setTimeout(wiggle, 600);
          visible = now;
        }, { threshold: [0, .6] }).observe(send);
        setInterval(() => { if (visible) wiggle(); }, 5200);
      }

      // Anfrage angekommen (Shopify lädt nach dem Senden neu): großer Jubel mit Löwen-Stickern
      if (form.classList.contains('is-sent')) {
        form.closest('section')?.scrollIntoView({ block: 'center' });
        setTimeout(() => burst(form.querySelector('.ll-form__thanks') || form, { count: 50, lions: 6, spread: 520 }), 500);
      }
    }

    root.querySelectorAll('a[data-type]').forEach((a) => a.addEventListener('click', () => setType(a.dataset.type)));

    // Bühnen neigen sich leicht mit dem Zeiger
    if (!reduce && matchMedia('(hover: hover)').matches) {
      root.querySelectorAll('.ll-stage').forEach((el) => {
        el.addEventListener('pointermove', (e) => {
          const r = el.getBoundingClientRect();
          const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
          el.classList.add('is-tilting');
          el.style.transform = `perspective(900px) rotateY(${x * 7}deg) rotateX(${-y * 7}deg)`;
        });
        el.addEventListener('pointerleave', () => { el.classList.remove('is-tilting'); el.style.transform = ''; });
      });
    }
  }

  const start = () => document.querySelectorAll('.ll').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('.ll').forEach(init));
})();
